import React, { useEffect, useState } from "react";
import { Breadcrumb, Col, Container, Row } from "react-bootstrap";
import "./OrderStage.scss";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import nvCookieHelpers from "../../services/cookieService";
const OrderStages: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const pathSegments = location.pathname.split('/');

  useEffect(() => {
    let lastParameter = (pathSegments[pathSegments.length - 1]).length ? pathSegments[pathSegments.length - 1] : pathSegments[pathSegments.length - 2];
    if (lastParameter === 'user') {
      lastParameter = pathSegments[pathSegments.length - 1];
      if ((lastParameter === 'cart')) {
        lastParameter = pathSegments[pathSegments.length - 2];
        if (nvCookieHelpers.getCookie('isUserLoggedIn')) {
          lastParameter = 'loggedIn'
        }
      }
    }
    setCurrentStep(lastParameter);
  }, [pathSegments]);

  const [currentStep, setCurrentStep] = useState<string>('');

  return (
    <div className="OrderStages">
      <Container>
        <Row xs={'auto'} md={'auto'}>
          <Col md={12}>
            <div className="stageContainer">
              <Breadcrumb>
                <Breadcrumb.Item active={currentStep === 'loggedIn' || currentStep === 'guest' || currentStep === 'cart'}>{t('CHECKOUT_PAYMENT_HEADER')}</Breadcrumb.Item>
                <Breadcrumb.Item active={currentStep === 'verify'}>{t('BTN_REVIEW_ORDER')}</Breadcrumb.Item>
                <Breadcrumb.Item active={currentStep === 'thankyou'}>{t('CHECKOUT_ORDER_SUBMITTED')}</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default OrderStages;
